export default function Services() {
  return (
    <section id="services">
      <div className="reveal">
        <div className="sec-label">What We Do</div>
        <h2 className="sec-title">
          Everything your event<br />
          <em>needs, handled.</em>
        </h2>
      </div>

      <div className="services-grid">
        {[
          { icon: "📋", num: "01", title: "Full Event Planning", desc: "End-to-end planning from concept to cleanup. You relax, we handle every single detail so your day is perfect." },
          { icon: "🎨", num: "02", title: "Décor & Styling", desc: "Floral arrangements, stage setup, balloon decorations, mandap design, lighting — beautiful décor within your budget." },
          { icon: "🤝", num: "03", title: "Vendor Coordination", desc: "We manage all your vendors — makeup, catering, photography, DJ and more — so nothing slips through the cracks." },
          { icon: "🍽️", num: "04", title: "Catering Arrangements", desc: "Veg, non-veg, multi-cuisine spreads, live counters, and sweet stalls — we get you the best caterers in your price range." },
          { icon: "🎵", num: "05", title: "Entertainment & Music", desc: "DJs, live music, emcees, folk performers, sangeet artists, and anchors who keep your crowd energised." },
          { icon: "📅", num: "06", title: "Day-Of Coordination", desc: "On the day itself, our team manages timelines, vendors, and flow — so you enjoy every moment." }
        ].map((service, i) => (
          <div key={i} className={`service-card reveal reveal-delay-${i % 3}`}>
            <span className="service-icon">{service.icon}</span>
            <div className="service-num">{service.num}</div>
            <div className="service-title">{service.title}</div>
            <p className="service-desc">{service.desc}</p>
            <span className="service-arrow">→</span>
          </div>
        ))}
      </div>
    </section>
  );
}